import React from 'react'
import { Text, View } from 'oio-react'
import { useParams } from 'react-router-dom'
import InitiativeList from 'src/apps/Initiative/components/List'
import InitiativeListItemRow from 'src/apps/Initiative/components/ListItemRow'
import DiscussionListItemRow from 'src/apps/Discussions/components/ListItemRow'

const ProfileRecentsBlock = () => {
   const { userId } = useParams()
   const initiativeListFilter = {
      limit: 7,
      sortBy: 'dateLastUpdated',
      userRelationshipFilter: {
         userId,
         hasElementType: 'roleParticipant'
      }
   }

   return (
      <View
         position="relative"
         float="left"
         width="100%"
         border="1px solid #eee[d-f]"
         padding="20px[d-f]"
         marginBottom="40px">
         <View
            float="left"
            width="100%"
            paddingBottom="20px"
            borderBottom="1px solid #eee">
            <Text
               size="3"
               weight="medium"
               color="#111">
               Recents
            </Text>
         </View>
         <View
            float="left"
            width="100%"
            padding="5px 0px">
            <InitiativeList filter={initiativeListFilter}>
               {initiativeList => initiativeList.items.map((initiative, index) => {
                  const ListItemRow = initiative.class === 'discussion'
                     ? DiscussionListItemRow
                     : InitiativeListItemRow

                  return (
                     <ListItemRow
                        key={initiative.id}
                        addedBy={initiative.addedBy.fullName}
                        archived={initiative.archived}
                        coverUrl={initiative.coverMedia?.file.thumbnailUrlW480}
                        dateLastUpdated={initiative.dateLastUpdated}
                        discussionFormat={initiative.discussionFormat}
                        discussionIsClosed={initiative.discussionStatus?.closed}
                        hasUnreadEntries={initiative.thread.hasUnreadEntries}
                        linkTo={`/initiatives/${initiative.slug}`}
                        name={initiative.name}
                        numThreadEntries={initiative.thread.numEntries}
                        numViews={initiative.numViews}
                        pinned={initiative.pinned}
                        privacy={initiative.privacy}
                        slug={initiative.slug}
                        typeSlug={initiative.type.slug}
                        borderStyle={index === 0 ? 'none' : '1px solid #eee'}
                     />
                  )
               })}
            </InitiativeList>
         </View>
      </View>
   )
}

export default ProfileRecentsBlock
